import { render } from "./UseCases.vue?vue&type=template&id=bf1c0020"
import script from "./UseCases.vue?vue&type=script&lang=js"
export * from "./UseCases.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__